import styles from "./ContractStyles";
import robotoLight from "../fonts/Roboto-Regular.ttf";
import robotoBold from "../fonts/Roboto-Bold.ttf";
import robotoItalic from "../fonts/Roboto-Italic.ttf";
import { Font } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  src: robotoLight,
});
Font.register({
  family: "Roboto-Italic",
  src: robotoItalic,
});
Font.register({
  family: "Roboto-Bold",
  src: robotoBold,
});

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        margin: 10,
        marginLeft: 20,
        paddingTop: 10,
      },
      items: [
        {
          type: "text",
          styles: {
            fontSize: 11,
            marginTop: 15,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
          },
          content:
            "RIDER TO THE AGREEMENT WITHOUT MODIFICATION OF CONTRACTUAL PRICE",
        },
        {
          type: "text",
          styles: {
            fontFamily: "Helvetica-Oblique",
            textAlign: "center",
            paddingLeft: 40,
            paddingRight: 40,
            fontSize: 11,
          },
          content:
            "Table of changes during the cruise, representing a rider to the Agreement without impact on the contractually agreed price",
        },
        {
          type: "text",
          styles: {
            ...styles.textContent,
            fontFamily: "Roboto-Bold",
            fontSize: 9,
            marginTop: 10,
          },
          content: "CHANGES OF PORTS OF CALL",
        },
        {
          type: "text",
          styles: {
            fontSize: 9,
            fontFamily: "Helvetica-Oblique",
            marginBottom: 30,
          },
          content:
            "(Indicate the port/s of call which have been cancelled, replaced and/or added and initial - Client and Captain)",
        },
        {
          type: "view",
          styles: {
            border: "none",
            //padding: "5pt",
            height: "80vh",
          },
          items: [
            //  {
            //     type: "view",
            //     styles: {
            //       flexDirection: "row",
            //     },
            //     items: [
            //       {
            //         type: "view",
            //         styles: {
            //           width: "80%",
            //           height: "80vh",
            //         },
            //         items: [],
            //       },
            //     ],
            //   },

            {
              type: "view",
              //repeated: true,
              repeated: false,
              findRepeated: "changeOfPorts_content",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "100%",
                    position: "absolute",
                    right: 0,
                  },
                  items: [
                    {
                      type: "view",
                      items: [
                        // {
                        //   type: "text",
                        //   styles: {
                        //     ...styles.textContent,
                        //     fontSize: 11,
                        //   },
                        //   //content: "__changeOfPorts_content__",
                        //   //content: "",
                        // },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            position: "absolute",
                            top: -10,
                            right: 0,
                          },
                          items: [
                            {
                              type: "text",
                              styles: {
                                fontSize: 8,
                                paddingRight: 15,
                              },
                              content: "CAPTAIN",
                            },
                            {
                              type: "text",
                              styles: { fontSize: 8, paddingRight: 10 },
                              content: "CLIENT",
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },

                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },

                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            marginTop: 15,
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flex: 1,
                                height: 1,
                                backgroundColor: "#000",
                                marginTop: 20,
                                marginRight: 100,
                                position: "relative",
                                width: "100%",
                              },
                              items: [{}],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 40,
                                    marginRight: 5,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              type: "view",
                              items: [
                                {
                                  type: "view",
                                  specialType: "checkbox",
                                  styles: {
                                    ...styles.checkbox,
                                    width: 40,
                                    height: 20,
                                    right: 0,
                                    borderRadius: 0,
                                  },
                                  items: [],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    // {
    //   type: "view",

    //   styles: {
    //     flexDirection: "row",
    //   },
    //   items: [
    //     {
    //       type: "view",

    //       items: [
    //         {
    //           type: "text",
    //           styles: {
    //             fontSize: 8,
    //             marginBottom: 5,
    //             paddingRight: 100,
    //           },

    //           content: "AGREEMENT ON CHANGES OF PORTS OF CALL",
    //         },
    //       ],
    //     },
    //     {
    //       type: "view",

    //       items: [
    //         {
    //           type: "text",
    //           styles: {
    //             fontSize: 8,
    //             marginTop: 5,
    //             marginBottom: 5,
    //             marginRight: 40,
    //           },

    //           content: "CAPTAIN ______________",
    //         },
    //       ],
    //     },
    //     {
    //       type: "view",

    //       items: [
    //         {
    //           type: "text",
    //           styles: {
    //             fontSize: 8,
    //             marginTop: 5,
    //             marginBottom: 5,
    //           },

    //           content: "CLIENT _______________",
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      type: "view",
      styles: {
        padding: 10,
        marginTop: 0,
      },
      items: [
        {
          type: "text",
          styles: {
            fontSize: 11,
            marginTop: 40,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
          },
          content:
            "RIDER TO THE AGREEMENT WITHOUT MODIFICATION OF CONTRACTUAL PRICE",
        },
        {
          type: "text",
          styles: {
            fontFamily: "Helvetica-Oblique",
            textAlign: "center",
            paddingLeft: 40,
            paddingRight: 40,
            fontSize: 11,
            marginBottom: 20,
          },
          content:
            "Table of changes during the cruise, representing a rider to the Agreement without impact on the contractually agreed price",
        },
        {
          type: "text",
          styles: {
            ...styles.textContent,
            fontFamily: "Roboto-Bold",
            fontSize: 9,
            marginBottom: 5,
          },
          content:
            "INITIAL EMBARKATION AND EMBARKATIONS/DISEMBARKATIONS DURING THE VOYAGE",
        },
        {
          type: "text",
          styles: {
            fontSize: 9,
            fontFamily: "Helvetica-Oblique",
            marginBottom: 10,
          },
          content:
            "(Indicate the initial embarkation and successive embarkations/disembarkations and initial - Client and Captain)",
        },
        {
          type: "view",
          styles: {
            //border: "1pt solid #000000",
            flexDirection: "column",
          },
          items: [
            {
              type: "view",
              styles: { flexDirection: "row", width: "100%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginRight: 5,
                    textTransform: "uppercase",
                  },
                  content: "Initial embarkations",
                },
                {
                  type: "text",
                  styles: { fontSize: 9 },
                  content: "__changeOfEmbarkation_initial__",
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    position: "absolute",
                    right: 35,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginRight: 50,
                      },
                      content: "CAPTAIN",
                    },
                    {
                      type: "text",
                      styles: { fontSize: 8 },
                      content: "CLIENT",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                marginTop: 10,
                flexDirection: "row",
                width: "100%",
                //borderRight: "1pt solid #000000",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    //width: "80%",
                    height: "80vh",
                    //padding: 10,
                  },
                  items: [
                    {
                      type: "view",
                      repeated: true,
                      findRepeated: "changeOfPorts_content",
                      styles: {
                        flexDirection: "row",
                      },
                      items: [
                        {
                          type: "view",
                          styles: {
                            flexDirection: "row",
                            marginBottom: 20,
                            width: "100%",
                            // width: "80%",
                          },
                          items: [
                            {
                              type: "view",
                              styles: {
                                flexDirection: "column",
                                width: "25%",
                              },
                              items: [
                                {
                                  type: "text",
                                  styles: {
                                    ...styles.textContent,
                                    fontSize: 9,
                                    textTransform: "uppercase",
                                    marginBottom: 5,
                                  },
                                  content: "Port of call",
                                },
                                {
                                  type: "text",
                                  styles: {
                                    ...styles.textContent,
                                    fontSize: 9,
                                  },
                                  content: "__changeOfPorts_content__",
                                  //content: "",
                                },
                              ],
                            },
                            {
                              type: "view",
                              styles: {
                                flexDirection: "row",
                                width: "50%",
                                alignItems: "center",
                              },
                              items: [
                                {
                                  type: "view",
                                  styles: {
                                    flexDirection: "column",
                                    marginRight: 10,
                                  },
                                  items: [
                                    {
                                      type: "text",
                                      styles: {
                                        ...styles.textContent,
                                        fontSize: 9,
                                        textTransform: "uppercase",
                                        marginBottom: 5,
                                      },
                                      content: "Disembarkations",
                                    },
                                    {
                                      type: "text",
                                      styles: {
                                        ...styles.textContent,
                                        fontSize: 9,
                                        textTransform: "uppercase",
                                      },
                                      content: "Embarkations",
                                      //content: "",
                                    },
                                  ],
                                },
                                {
                                  type: "view",
                                  styles: {
                                    flexDirection: "column",
                                  },
                                  items: [
                                    {
                                      type: "text",
                                      styles: {
                                        ...styles.textContent,
                                        fontSize: 9,
                                        marginBottom: 5,
                                      },
                                      content:
                                        "__changeOfEmbarkation_disembarkations__",
                                    },
                                    {
                                      type: "text",
                                      styles: {
                                        ...styles.textContent,
                                        fontSize: 9,
                                      },
                                      content:
                                        "__changeOfEmbarkation_embarkations__",
                                      //content: "",
                                    },
                                  ],
                                },
                              ],
                            },

                            {
                              type: "view",
                              styles: {
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                position: "absolute",
                                right: 0,
                              },
                              items: [
                                {
                                  type: "view",
                                  items: [
                                    {
                                      type: "view",
                                      specialType: "checkbox",
                                      styles: {
                                        ...styles.checkbox,
                                        width: 40,
                                        height: 20,
                                        right: 40,
                                        marginRight: 5,
                                        borderRadius: 0,
                                      },
                                      items: [],
                                    },
                                  ],
                                },
                                {
                                  type: "view",
                                  items: [
                                    {
                                      type: "view",
                                      specialType: "checkbox",
                                      styles: {
                                        ...styles.checkbox,
                                        width: 40,
                                        height: 20,
                                        right: 0,
                                        borderRadius: 0,
                                      },
                                      items: [],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            // {
            //   type: "view",
            //   styles: {
            //     flexDirection: "column",
            //     //width: "50%",
            //     padding: 10,
            //   },
            //   items: [
            //     {
            //       type: "text",
            //       styles: {
            //         ...styles.textContent,
            //         fontFamily: "Roboto-Bold",
            //         fontSize: 9,
            //         textTransform: "uppercase",
            //       },
            //       content: "Embarkations/Disembarkations",
            //     },
            //     {
            //       type: "text",
            //       styles: {
            //         ...styles.textContent,
            //         fontFamily: "Helvetica-Oblique",
            //         fontSize: 6,
            //       },
            //       content:
            //         "(you may refer to initial passengers by their number on passenger list)",
            //     },
            //   ],
            // },
          ],
        },
        // {
        //   type: "view",

        //   styles: {
        //     flexDirection: "row",
        //     position: "absolute",
        //     bottom: 10,
        //   },
        //   items: [
        //     {
        //       type: "view",

        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 8,
        //             marginBottom: 5,
        //             paddingRight: 100,
        //           },

        //           content: "AGREEMENT ON EMBARKATIONS/DISEMBARKATIONS",
        //         },
        //       ],
        //     },
        //     {
        //       type: "view",

        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 8,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             marginRight: 40,
        //           },

        //           content: "CAPTAIN ______________",
        //         },
        //       ],
        //     },
        //     {
        //       type: "view",

        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 8,
        //             marginTop: 5,
        //             marginBottom: 5,
        //           },

        //           content: "CLIENT _______________",
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
    },
    {
      type: "view",
      styles: {
        flexDirection: "row",
      },
      items: [
        {
          type: "view",
          styles: {
            width: "100%",
            height: "95vh",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 25,
                marginLeft: 80,
                marginRight: 80,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 18,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "APPENDIX II",
                },
                 {
                  type: "text",
                  styles: {
                    fontSize: 18,
                    fontFamily: "Roboto-Bold",
                  },
                  content: " — ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 16,
                    fontFamily: "Roboto-Bold",
                  },
                  content:
                    "COMMERCIAL PRESENTATION OF THE VESSEL AND SCOPE OF SERVICES",
                },
              ],
            },

            {
              type: "text",
              styles: {
                fontFamily: "Helvetica-Oblique",
                textAlign: "center",
                paddingLeft: 20,
                paddingRight: 20,
                fontSize: 9,
                marginTop: 5,
              },
              content:
                "Attach leaflet, brochure or website printout showing the commercial presentation of the vessel and services",
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
